import { z, ZodType } from 'zod';
import {
    openingTypeSchema,
    VariantSizeType,
    variantSizeTypeSchema,
    VariantType,
    variantTypeSchema,
    widgetBaseSchema,
    WidgetsName,
    WidgetType,
} from './common';
import { zObject } from '../../util/zod';

export const openingTypeLinkSchema = z.object({
    url: z.string(),
    target: z.string(),
});
export type OpeningTypeLink = z.infer<typeof openingTypeLinkSchema>;

export const openingTypeAnchorSchema = z.object({
    uniqid: z.string(),
});
export type OpeningTypeAnchor = z.infer<typeof openingTypeAnchorSchema>;

export const openingTypePopupSchema = z.object({
    title: z.string(),
    widgets: widgetBaseSchema.array(),
});
export type OpeningTypePopup = z.infer<typeof openingTypePopupSchema>;

export type WidgetButtonProps = {
    text?: string;
    color?: string;
    backgroundColor?: string;
    borderRadius?: string;
    fontSize?: string;
    buttonSize?: VariantSizeType;
    variant?: VariantType;
    url?: string;
    target?: string;
};
export const widgetButtonPropsSchema = zObject<WidgetButtonProps>({
    text: z.string().optional(),
    color: z.string().optional(),
    backgroundColor: z.string().optional(),
    borderRadius: z.string().optional(),
    fontSize: z.string().optional(),
    buttonSize: variantSizeTypeSchema.optional(),
    variant: variantTypeSchema.optional(),
    url: z.string().optional(),
    target: z.string().optional(),
});

export const widgetArticleButtonContentSchema = widgetButtonPropsSchema.extend({
    openingType: openingTypeSchema.optional(),
    openingTypeLink: openingTypeLinkSchema.optional(),
    openingTypeAnchor: openingTypeAnchorSchema.optional(),
    openingTypePopup: openingTypePopupSchema.optional(),
});
export type WidgetArticleButtonContent = z.infer<typeof widgetArticleButtonContentSchema>;

export type WidgetArticleButtonType = {
    name: WidgetsName.ArticleButton;
    uniqid: string;
    content: WidgetArticleButtonContent;
};
export const widgetArticleButtonTypeSchema = zObject<WidgetArticleButtonType>({
    name: z.literal(WidgetsName.ArticleButton),
    uniqid: z.string(),
    content: widgetArticleButtonContentSchema,
}) satisfies ZodType<WidgetType<WidgetArticleButtonContent>>;
